import { render, staticRenderFns } from "./_SchedulerSettings.vue?vue&type=template&id=9806c538"
import script from "./_SchedulerSettings.vue?vue&type=script&lang=ts"
export * from "./_SchedulerSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports